import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  root: css`
    border: 0;
    border-top: 1px solid ${cssTheme.default.day.line};
    inline-size: 100%;
  `,
}
